module.exports = __webpack_public_path__ + "img/ae1fbeb78e830cfa728d7b05255baa7a.png";